export default __webpack_public_path__ + "static/media/02d_folded.b303824e.png";